import React, { useState } from "react";
import LangSvg from "../../images/languages";
import userData from "../../userdata.json";

function Card({ card }) {
  const [isFliped, setIsFliped] = useState(false);
  const toggleFLip = () => {
    setIsFliped((prevIsFlip) => !prevIsFlip);
  };
  return (
    <div
      className={`w-100 h-100  project_card_inner  relative ${
        isFliped ? "flip" : ""
      }`}
    >
      <div
        className={`card_face glassmorphic-3  flex justify-center items-center w-100 h-100 absolute br3`}
      >
        <div className="pa2 flex flex-column justify-end items-center ">
          <span className="f2-l f3">{card?.title}</span>
          <div className="flex mt3">
            {(card?.langs || []).map((lang) => (
              <div className="mr2 ml2">
                <LangSvg lang={lang} className="w2 h2" />
              </div>
            ))}
          </div>
          <button
            className="ba bg-transparent button-transition primary glassmorphic-2 pv2 ph3 br2 pointer mt4"
            onClick={toggleFLip}
          >
            Learn More
          </button>
        </div>
      </div>
      <div
        className="card_face glassmorphic-3 w-100 h-100 absolute card_face--back pointer pv3 ph4 flex justify-center flex-column items-center"
        onClick={toggleFLip}
      >
        <div className="f3-l f4">{card?.title}</div>
        <ul className="ph3-l ph1 f5 lh-copy-l">
          {(card?.points || []).map((point) => (
            <li className="f6">{point}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
function Projects() {
  const { projects } = userData || {};
  return (
    <div id="Projects" className="pt6">
      <div className=" f1 mb5 flex">
        <hr className="w-50" />
        <span className="mh3">Projects</span>
        <hr className="w-50" />
      </div>
      <div className="flex justify-center mb4 flex-wrap">
        {(projects || []).map((card) => (
          <div className=" w-30-l w-80 h5-5-l h5 ml5-l mb5">
            <Card card={card} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
